<!--
 * @Description  : 开票记录 --- 详情页
 * @Author       : zl
 * @Date         : 2024-07-18 10:07:38
 * @LastEditors  : 王帅
 * @LastEditTime : 2025-09-09 11:47:42
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\invoice\history-detail.vue
-->
<template>
	<div class="h100 details">
		<div class="content">
			<el-form :model="detailData" label-width="170px" size="small">
				<el-row class="mt10">
					<el-col :span="6">
						<el-form-item label="流水号：">
							<el-input v-model="detailData.orderId" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="开票方式：">
							<el-input v-model="detailData.wayName" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="申请时间：">
							<el-input v-model="detailData.issueTimeDate" disabled></el-input>
						</el-form-item>
					</el-col>
					<!-- 线上开票展示查看发票按钮 -->
					<el-col :span="6" v-if="detailData.isLine  == 0">
						<el-form-item label="发票：">
							<el-button type="primary" @click="toViewInvoice">查看发票</el-button>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="mt10">
					<el-divider content-position="left">销方信息：</el-divider>
					<el-col :span="6">
						<el-form-item label="纳税人名称(销方)：">
							<el-input v-model="detailData.taxPayNameDem" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="纳税人识别号(销方)：">
							<el-input v-model="detailData.taxPayNoDem" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="地址(销方)：">
							<el-tooltip effect="light" :content="detailData.addressDem" placement="top"
								:disabled="!detailData.addressDem">
								<el-input v-model="detailData.addressDem" disabled></el-input>
							</el-tooltip>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="电话(销方)：">
							<el-input v-model="detailData.phoneDem" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="开户行(销方)：">
							<el-input v-model="detailData.bankDem" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="银行账号(销方)：">
							<el-input v-model="detailData.accountDem" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="税控设备编号：">
							<el-input v-model="detailData.deviceNoDem" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="开票终端标识：">
							<el-input v-model="detailData.deviceNoDem" disabled></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="mt10">
					<el-divider content-position="left">购方信息：</el-divider>
					<el-col :span="6">
						<el-form-item label="纳税人名称(购方)：">
							<el-input v-model="detailData.taxPayNameBuy" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="纳税人识别号(购方)：">
							<el-input v-model="detailData.taxPayNoBuy" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="地址(购方)：">
							<el-tooltip effect="light" :content="detailData.addressBuy" placement="top"
								:disabled="!detailData.addressBuy">
								<el-input v-model="detailData.addressBuy" disabled></el-input>
							</el-tooltip>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="电话(购方)：">
							<el-input v-model="detailData.phoneBuy" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="开户行(购方)：">
							<el-input v-model="detailData.bankBuy" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="银行账号(购方)：">
							<el-input v-model="detailData.accountBuy" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="联系方式(购方)：">
							<el-input v-model="detailData.contactsBuy" disabled></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="mt10">
					<el-divider content-position="left">开票信息：</el-divider>
					<el-row>
						<el-col :span="6">
							<el-form-item label="开票类型：">
								<el-select v-model="detailData.invoiceType" disabled>
									<el-option :value="0" label="正数发票开具"></el-option>
									<el-option :value="1" label="负数发票开具（红冲）"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="征税方式：">
								<el-select v-model="detailData.taxType" disabled>
									<el-option :value="0" label="普通征税"></el-option>
									<el-option :value="2" label="差额征税"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="发票类型：">
								<el-input v-model="detailData.typeCodeName" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="6">
							<el-form-item label="开票人：">
								<el-input v-model="detailData.drawer" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="复核人：">
								<el-input v-model="detailData.reviewer" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="收款人：">
								<el-input v-model="detailData.payee" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="备注：">
								<el-tooltip effect="light" :content="detailData.remark" placement="top"
									:disabled="!detailData.remark">
									<el-input v-model="detailData.remark" disabled></el-input>
								</el-tooltip>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="通知单编号：">
								<el-input v-model="detailData.letterNo" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="特殊票种标识：">
								<el-select v-model="detailData.tag" disabled>
									<el-option value="00" label="非特殊票种"></el-option>
									<el-option value="01" label="农产品销售"></el-option>
									<el-option value="02" label="农产品收购"></el-option>
									<el-option value="06" label="抵扣通行费"></el-option>
									<el-option value="08" label="成品油"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<!-- <el-col :span="6">
							<el-form-item label="原发票代码：">
								<el-input v-model="detailData.oldInvoiceCode"
										  disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="原发票号码：">
								<el-input v-model="detailData.oldInvoiceNo"
										  disabled></el-input>
							</el-form-item>
						</el-col> -->
						<el-col :span="6">
							<el-form-item label="开票日期：">
								<el-input v-model="detailData.issueTimeDate" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="开票状态：">
								<el-select v-model="detailData.status" disabled>
									<el-option :value="-1" label="待开票"></el-option>
									<el-option :value="0" label="开票中"></el-option>
									<el-option :value="1" label="开票成功"></el-option>
									<el-option :value="2" label="开票失败"></el-option>
									<el-option :value="3" label="红冲申请中"></el-option>
									<el-option :value="4" label="红冲成功"></el-option>
									<el-option :value="5" label="红冲失败"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="6" v-if="detailData.status == 0">
							<el-form-item label="失败原因：">
								<el-input v-model="detailData.receiveMsg" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-row>
				<el-row v-for="(item, index) in detailData.operateRecordDetailList" :key="'msg' + index" class="mt10">
					<el-divider content-position="left">
						开票信息明细
						<span class="ml10">#{{ index + 1 }}：</span>
					</el-divider>
					<el-col :span="6">
						<el-form-item label="发票行性质：">
							<el-select v-model="item.property" disabled>
								<el-option :value="0" label="正常行"></el-option>
								<el-option :value="1" label="折扣行"></el-option>
								<el-option :value="2" label="被折扣行"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="商品名称：">
							<el-input v-model="item.proName" disabled></el-input>
						</el-form-item>
					</el-col>

					<el-col :span="6">
						<el-form-item label="规格型号：">
							<el-input v-model="item.specifications" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="单位：">
							<el-input v-model="item.unit" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="商品数量：">
							<el-input v-model="item.count" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="税率：">
							<el-input v-model="item.taxRate" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="含税金额：">
							<el-input v-model="item.includeValue" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="扣税金额：">
							<el-input v-model="item.deductValue" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="商品编码：">
							<el-input v-model="item.productNo" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="优惠政策标识：">
							<el-select v-model="item.isSpecial" disabled>
								<el-option :value="0" label="不使用"></el-option>
								<el-option :value="1" label="使用"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="0税率标识：">
							<el-select v-model="item.zeroRate" disabled>
								<el-option :value="0" label="出口退税"></el-option>
								<el-option :value="1" label="出口免税和其他免税优惠政策"></el-option>
								<el-option :value="2" label="不征增值税"></el-option>
								<el-option :value="3" label="普通零税率"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="增值税特殊管理：">
							<el-input v-model="item.specialControl" disabled></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>

		<div class="text-center footer hidden">
			<el-button class="btn cancel-btn" @click="goBack">返回</el-button>
		</div>

		<!-- 查看发票接口 -->
		<el-dialog center :close-on-click-modal="false" title="查看发票" :visible.sync="showInvoice" width="1000px">
			<iframe name="invoice" class="w100" frameborder="0" :src="viewSrc" height="600px" scrolling="no" />
		</el-dialog>
	</div>
</template>
<script>
import {
	getInvoiceInfoRecordInfo,
	getCheckEleInvoice,
} from 'api/modules/invoice'
export default {
	components: {},
	props: {
		detailId: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			detailData: {
				orderId: '', //订单编号

				taxPayNameDem: '', //纳税人（销方）
				taxPayNoDem: '', //纳税人识别号(销方)
				addressDem: '', //地址(销方)
				phoneDem: '', //电话(销方)
				bankDem: '', //开户行(销方)
				accountDem: '', //银行账号(销方)
				tagDem: '', //开票终端标识(销方)
				deviceNoDem: '', //销方税控设备编号(销方)

				taxPayNameBuy: '', //纳税人（购方）
				taxPayNoBuy: '', //纳税人识别号(购方)
				addressBuy: '', //地址（购方）
				phoneBuy: '', //电话(购方)
				bankBuy: '', //开户行(购方)
				accountBuy: '', //银行账号(购方)
				tagBuy: '', //开票终端标识(购方)
				deviceNoBuy: '', //销方税控设备编号(购方)
				contactsBuy: '', //邮箱或手机号(购方)

				tenantIdDem: '', //纳税人（销方）
				tenantIdBuy: '', //纳税人（购方）
				invoiceType: '', //发票类型 0:正数发票开具  1:负数发票开具（红冲）
				taxType: '', //征税方式 0:普通征税  2:差额征税
				tag: '', //特殊票种标识 00:非特殊票种 01:农产品销售 02:农产品收购 06:抵扣通行费 08:成品油
				way: '', //开票方式
				drawer: '', //开票人
				reviewer: '', //复核人
				payee: '', //收款人
				letterNo: '', //专票红字信息表编号（通知单编号）
				oldInvoiceCode: '', //原发票代码
				oldInvoiceNo: '', //原发票号码
				totalMoney: '', //合计金额(不含税开票金额)
				checkCode: '', //校验码
				invoiceCode: '', //发票代码
				invoiceNo: '', //发票号码
				receiveMsg: '', //返回信息
				issueTimeDate: '', //开票时间
				status: '', //0:开票失败  1:开票成功
				remark: '', //备注

				// 开票信息明细
				operateRecordDetailList: [
					{
						property: '', //发票行性质
						proName: '', //商品名称
						specifications: '', //规格型号
						unit: '', //单位
						count: '', // 数量
						taxRate: '', //税率
						includeValue: '', //含税金额
						deductValue: '', //扣税金额
						productNo: '', //商品编号
						isSpecial: '', //优惠政策标识 0 ：不使用，1 ： 使用
						zeroRate: '', //零税率标识  0：出口退税 1：出口免税和其他免税优惠政策  2：不征增值税  3：普通零税率
						specialControl: '', //增值税特殊管理
					},
				],
			},

			showInvoice: false,
			viewSrc: '',
		}
	},
	created() {
		this.getInvoiceInfoRecordInfo()
	},
	methods: {
		// 获取详情
		getInvoiceInfoRecordInfo() {
			getInvoiceInfoRecordInfo({
				id: this.detailId,
			}).then((d) => {
				if (d.operationCode == 1) {
					this.detailData = d.data
				}
			})
		},

		// 返回
		goBack() {
			this.$router.push({ path: '/invoice-history' })
		},

		// 查看发票
		toViewInvoice() {
			this.showInvoice = true
			// return
			getCheckEleInvoice({
				id:this.detailId,
			}).then((d) => {
				if (d.data.code == 0) {
					if (d.data.ddlsh) {
						this.viewSrc = d.data.fpurl
					} else {
						this.viewSrc = d.data.fpurl.includes('https')
							? d.data.fpurl
							: d.data.fpurl.replace(/http/i, 'https')
					}
				} else {
					this.$message.error(d.data.msg)
				}
			})
		},
	},
	computed: {},
}
</script>
<style lang="less" scoped>
.details {
	position: relative;

	.content {
		height: calc(100% - 30px);
		padding-bottom: 40px;
		padding: 20px 0;
	}

	.footer {
		position: absolute;
		bottom: 0;
		left: 0;
		box-sizing: border-box;
		border-top: 1px solid #eee;
		box-shadow: 0 -2px 1px #f3f3f3;
		width: 100%;
		height: 60px;
		padding: 10px 0;
		background: #fff;
		text-align: center;
		white-space: nowrap;
		z-index: 999;

		.el-button {
			width: 120px !important;
			height: 40px !important;
		}
	}
}
</style>
